<template>
    <div class="homeMain">
        <div class="homeLeft">
            <div class="homeMap">
                <img
                    src="../../../assets/supervise/borderTrange.png"
                    alt=""
                    srcset=""
                    class="trangle trangle1"
                />
                <img
                    src="../../../assets/supervise/borderTrange.png"
                    alt=""
                    srcset=""
                    class="trangle trangle2"
                />
                <img
                    src="../../../assets/supervise/borderTrange.png"
                    alt=""
                    srcset=""
                    class="trangle trangle3"
                />
                <img
                    src="../../../assets/supervise/borderRight.png"
                    alt=""
                    srcset=""
                    class="trangleRight"
                />

                <div id="serveMap" class="serveMap"></div>
            </div>
            <div class="homeVersion">
                <img
                    src="../../../assets/supervise/homeBottom.png"
                    class="companyImg"
                    alt=""
                    srcset=""
                />
                <p class="serveTitle">异常工单</p>
                <div class="serveAbnormal">
                    <div class="companyHead">
                        <span class="item2">工单流水号</span>
                        <span class="item">姓名</span>
                        <span class="item">类型</span>
                        <span class="item">状态</span>
                    </div>
                    <!--  @click.stop="clickAbnormal($event)" -->
                    <div class="compayDes" @click.stop="clickAbnormal($event)">
                        <vue-seamless-scroll
                            :style="{
                                height: 130 + 'px',
                            }"
                            :data="tableData"
                            :class-option="classOption"
                            class="warp-content"
                        >
                            <div
                                class="desItem"
                                v-for="(item, index) in tableData"
                                :key="index"
                            >
                                <p
                                    class="item2"
                                    :id="index"
                                    :data-obj="JSON.stringify(item)"
                                >
                                    {{ item.orderNum }}
                                </p>
                                <p
                                    class="item"
                                    :id="index"
                                    :data-obj="JSON.stringify(item)"
                                >
                                    {{ item.customerName }}
                                </p>
                                <p
                                    class="item"
                                    :id="index"
                                    :data-obj="JSON.stringify(item)"
                                >
                                    <span
                                        v-if="item.exceptionStatus == 1"
                                        :id="index"
                                        :data-obj="JSON.stringify(item)"
                                        >位置异常</span
                                    >
                                    <span
                                        v-if="item.exceptionStatus == 2"
                                        :id="index"
                                        :data-obj="JSON.stringify(item)"
                                        >时间异常</span
                                    >
                                </p>
                                <p
                                    class="item"
                                    :id="index"
                                    :data-obj="JSON.stringify(item)"
                                >
                                    <span
                                        v-if="
                                            item.processStatus == '' ||
                                            item.processStatus == null
                                        "
                                        :id="index"
                                        :data-obj="JSON.stringify(item)"
                                        >未处置</span
                                    >
                                    <span
                                        v-if="
                                            item.processStatus == '1' ||
                                            item.processStatus == '2'
                                        "
                                        :id="index"
                                        :data-obj="JSON.stringify(item)"
                                        >已处置</span
                                    >
                                </p>
                            </div>
                        </vue-seamless-scroll>
                    </div>
                </div>
            </div>
        </div>
        <div class="homeCenter">
            <img
                src="../../../assets/supervise/workCenter.png"
                class="companyImg"
                alt=""
                srcset=""
            />
            <div class="centerMain">
                <div class="centerHead">
                    <div class="centerSelcet">
                        <p class="selectName" @click="showDrop">
                            <span>{{ selectName }}</span>
                            <i
                                :class="
                                    selectShow == false
                                        ? 'el-icon-arrow-down'
                                        : 'el-icon-arrow-up'
                                "
                                class="cion"
                            ></i>
                        </p>
                        <ul class="selectDrop" v-show="selectShow == true">
                            <li
                                :class="selectIndex == index ? 'selectCur' : ''"
                                @click="tapChoose(index, item.name, item.id)"
                                v-for="(item, index) in selectList"
                                :key="index"
                            >
                                <span> {{ item.name }}</span>
                            </li>
                        </ul>
                    </div>

                    <div class="centerInput">
                        <input v-model="queryName" placeholder="请输入姓名" />
                    </div>
                    <p class="centerButton" @click="searchHua">查询</p>
                    <p class="centerTotal">总共：{{ total }}</p>
                    <p class="centerLine">在线：{{ onLine }}</p>
                </div>
                <div class="centerContent">
                    <div
                        class="centerItem"
                        v-for="(item, index) in concatList"
                        :key="index"
                    >
                        <div class="centerInfo" @click="personTap(index, item)">
                            <img
                                src="../../../assets/supervise/feiman.png"
                                class="companyImg"
                                alt=""
                                srcset=""
                            />
                            <!-- v-if="item.actionType == 0" -->
                            <!-- <img
                                v-if="item.actionType == 2"
                                src="../../../assets/supervise/man.png"
                                class="companyImg"
                                alt=""
                                srcset=""
                            />
                            <img
                                v-if="item.actionType == null"
                                src="../../../assets/supervise/emptyHead.png"
                                alt=""
                                srcset=""
                                class="centerImg"
                            /> -->
                            <!-- <img
                                v-else
                                :src="item.photo"
                                alt=""
                                srcset=""
                                class="centerImg"
                            /> -->
                            <div class="centerName">
                                <el-tooltip
                                    class="item"
                                    effect="light"
                                    :content="item.agentID"
                                    placement="top-start"
                                >
                                    <p class="centerTip">
                                        {{ item.agentID }}
                                    </p>
                                </el-tooltip>
                                <el-tooltip
                                    class="item"
                                    effect="light"
                                    :content="item.actionType"
                                    placement="top-start"
                                >
                                    <p
                                        class="centerTip"
                                        v-if="item.actionType == -1"
                                    >
                                        离线
                                    </p>
                                    <p
                                        class="centerTip"
                                        v-if="item.actionType == 0"
                                    >
                                        置闲
                                    </p>
                                    <!-- <p class="centerTip" v-if="item.ActionType == '1'">置</p> -->
                                    <p
                                        class="centerTip"
                                        v-if="item.actionType == 2"
                                    >
                                        置忙
                                    </p>
                                    <p
                                        class="centerTip"
                                        v-if="item.actionType == 3"
                                    >
                                        保持
                                    </p>
                                    <p
                                        class="centerTip"
                                        v-if="item.actionType == 4"
                                    >
                                        拨号
                                    </p>
                                    <p
                                        class="centerTip"
                                        v-if="item.actionType == 5"
                                    >
                                        挂断
                                    </p>
                                    <p
                                        class="centerTip"
                                        v-if="item.actionType == 6"
                                    >
                                        小休
                                    </p>
                                </el-tooltip>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="homeRight">
            <div class="versionOne" v-if="showPerson == false">
                <img
                    src="../../../assets/supervise/workRight.png"
                    class="companyImg"
                    alt=""
                    srcset=""
                />
                <div class="verserMain">
                    <div class="rightTop">
                        <img
                            class="icon"
                            src="../../../assets/supervise/workTip.png"
                            alt=""
                            srcset=""
                        />
                        <p class="name">工单统计</p>
                        <div class="rightPick">
                            <el-date-picker
                                v-model="pickTime"
                                v-show="centerFull == false"
                                type="date"
                                placeholder="请选择"
                                size="mini"
                                style="width: 100%"
                                value-format="yyyy-MM-dd"
                                format="yyyy-MM-dd"
                                @change="changeTap"
                            >
                            </el-date-picker>
                            <el-date-picker
                                v-show="centerFull == true"
                                v-model="pickTime"
                                :append-to-body="false"
                                type="date"
                                placeholder="请选择"
                                size="mini"
                                style="width: 100%"
                                value-format="yyyy-MM-dd"
                                format="yyyy-MM-dd"
                                @change="changeTap"
                            >
                            </el-date-picker>
                        </div>
                    </div>
                    <div class="rightTab" v-if="workList.length > 0">
                        <p class="tabItem1">工单号</p>
                        <p class="tabItem">服务类别</p>
                        <p class="tabItem1">服务项目</p>
                    </div>
                    <div
                        class="rightDes"
                        @click.stop="clickProps($event)"
                        v-if="workList.length > 0"
                    >
                        <vue-seamless-scroll
                            :style="{
                                height: 721 + 'px',
                            }"
                            :data="workList"
                            :class-option="classOption"
                            class="warp-content"
                        >
                            <div
                                class="desItem"
                                v-for="(item, index) in workList"
                                :key="index"
                            >
                                <div
                                    class="item"
                                    :id="index"
                                    :data-obj="JSON.stringify(item)"
                                >
                                    <el-tooltip
                                        class="item"
                                        effect="light"
                                        :content="item.orderNum"
                                        placement="top-start"
                                    >
                                        <p
                                            class="rightTip"
                                            :id="index"
                                            :data-obj="JSON.stringify(item)"
                                        >
                                            {{ item.orderNum }}
                                        </p>
                                    </el-tooltip>
                                </div>

                                <div
                                    class="item"
                                    :id="index"
                                    :data-obj="JSON.stringify(item)"
                                >
                                    <el-tooltip
                                        class="item"
                                        effect="light"
                                        :content="item.servetypename"
                                        placement="top-start"
                                    >
                                        <p
                                            class="rightTip"
                                            :id="index"
                                            :data-obj="JSON.stringify(item)"
                                        >
                                            {{ item.servetypename }}
                                        </p>
                                    </el-tooltip>
                                </div>
                                <div
                                    class="item"
                                    :id="index"
                                    :data-obj="JSON.stringify(item)"
                                >
                                    <el-tooltip
                                        class="item"
                                        effect="light"
                                        :content="item.serveproductName"
                                        placement="top-start"
                                    >
                                        <p
                                            class="rightTip"
                                            :id="index"
                                            :data-obj="JSON.stringify(item)"
                                        >
                                            {{ item.serveproductName }}
                                        </p>
                                    </el-tooltip>
                                </div>
                            </div>
                        </vue-seamless-scroll>
                    </div>
                </div>
            </div>
            <div class="versionTwo" v-else>
                <div class="twoTop">
                    <img
                        src="../../../assets/supervise/rightTop2.png"
                        class="companyImg"
                        alt=""
                        srcset=""
                    />
                    <div class="personBox">
                        <img
                            src="../../../assets/supervise/normalIcon.png"
                            class="icon"
                            alt=""
                            srcset=""
                        />
                        <p class="name">基本信息</p>
                        <img
                            src="../../../assets/supervise/normalCanle.png"
                            class="close"
                            @click="closePerson"
                            alt=""
                            srcset=""
                        />
                    </div>
                    <div class="personModel">
                        <div class="personFlex">
                            <img
                                v-if="personInfo.photo == null"
                                src="../../../assets/supervise/avatar.png"
                                class="img"
                                alt=""
                                srcset=""
                            />
                            <img
                                v-else
                                :src="personInfo.photo"
                                class="img"
                                alt=""
                                srcset=""
                            />

                            <div class="personConent">
                                <ul>
                                    <li>姓名：{{ personInfo.name }}</li>
                                    <li>
                                        性别：{{
                                            personInfo.sex == 1 ? "女" : "男"
                                        }}
                                    </li>
                                    <li>年龄：{{ personInfo.age }}</li>
                                    <li>联系电话：{{ personInfo.phone }}</li>
                                </ul>
                            </div>
                        </div>
                        <p class="personAddress">
                            <img
                                src="../../../assets/supervise/addressCenter.png"
                                class="icon"
                                alt=""
                                srcset=""
                            />

                            <span class="name"
                                >详细地址：{{ personInfo.address }}</span
                            >
                        </p>
                    </div>
                    <div class="personOperate">
                        <p class="btn videoBtn" @click="concatVideo">
                            视频连接
                        </p>
                        <p class="btn feetBtn" @click="trajectoryTap">
                            查看轨迹
                        </p>
                    </div>
                    <!-- trajectoryState -->
                    <div class="trajectorySearch" v-show="trajectoryState">
                        <div class="datae">
                            <el-date-picker
                                v-show="centerFull == false"
                                style="width: 100%"
                                v-model="trajectoryTime"
                                value-format="yyyy-MM-dd"
                                format="yyyy-MM-dd"
                                type="datetimerange"
                                range-separator="至"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期"
                            >
                            </el-date-picker>
                            <el-date-picker
                                v-show="centerFull == true"
                                :append-to-body="false"
                                style="width: 100%"
                                v-model="trajectoryTime"
                                value-format="yyyy-MM-dd"
                                format="yyyy-MM-dd"
                                type="datetimerange"
                                range-separator="至"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期"
                            >
                            </el-date-picker>
                        </div>
                        <p class="btn">查询</p>
                    </div>
                </div>
                <div class="twoBottom">
                    <img
                        src="../../../assets/supervise/rightTop1.png"
                        class="companyImg"
                        alt=""
                        srcset=""
                    />
                    <div class="verserMain">
                        <div class="rightTop">
                            <img
                                class="icon"
                                src="../../../assets/supervise/workTip.png"
                                alt=""
                                srcset=""
                            />
                            <p class="name">工单统计</p>
                            <div class="rightPick">
                                <el-date-picker
                                    v-model="pickTime"
                                    v-show="centerFull == false"
                                    type="date"
                                    placeholder="请选择"
                                    size="mini"
                                    style="width: 100%"
                                    value-format="yyyy-MM-dd"
                                    format="yyyy-MM-dd"
                                    @change="changeTap"
                                >
                                </el-date-picker>
                                <el-date-picker
                                    v-show="centerFull == true"
                                    v-model="pickTime"
                                    :append-to-body="false"
                                    type="date"
                                    placeholder="请选择"
                                    size="mini"
                                    style="width: 100%"
                                    value-format="yyyy-MM-dd"
                                    format="yyyy-MM-dd"
                                    @change="changeTap"
                                >
                                </el-date-picker>
                            </div>
                        </div>
                        <div class="rightTab" v-if="workList.length > 0">
                            <p class="tabItem1">工单号</p>
                            <p class="tabItem">服务类型</p>
                            <p class="tabItem1">服务内容</p>
                        </div>
                        <div
                            class="rightDes1"
                            @click.stop="clickProps($event)"
                            v-if="workList.length > 0"
                        >
                            <vue-seamless-scroll
                                :style="{
                                    height: 337 + 'px',
                                }"
                                :data="workList"
                                :class-option="classOption"
                                class="warp-content"
                            >
                                <div
                                    class="desItem"
                                    v-for="(item, index) in workList"
                                    :key="index"
                                >
                                    <div
                                        class="item"
                                        :id="index"
                                        :data-obj="JSON.stringify(item)"
                                    >
                                        <el-tooltip
                                            class="item"
                                            effect="light"
                                            :content="item.orderNum"
                                            placement="top-start"
                                        >
                                            <p
                                                class="rightTip"
                                                :id="index"
                                                :data-obj="JSON.stringify(item)"
                                            >
                                                {{ item.orderNum }}
                                            </p>
                                        </el-tooltip>
                                    </div>

                                    <div
                                        class="item"
                                        :id="index"
                                        :data-obj="JSON.stringify(item)"
                                    >
                                        <el-tooltip
                                            class="item"
                                            effect="light"
                                            :content="item.servetypename"
                                            placement="top-start"
                                        >
                                            <p
                                                class="rightTip"
                                                :id="index"
                                                :data-obj="JSON.stringify(item)"
                                            >
                                                {{ item.servetypename }}
                                            </p>
                                        </el-tooltip>
                                    </div>
                                    <div
                                        class="item"
                                        :id="index"
                                        :data-obj="JSON.stringify(item)"
                                    >
                                        <el-tooltip
                                            class="item"
                                            effect="light"
                                            :content="item.serveproductName"
                                            placement="top-start"
                                        >
                                            <p
                                                class="rightTip"
                                                :id="index"
                                                :data-obj="JSON.stringify(item)"
                                            >
                                                {{ item.serveproductName }}
                                            </p>
                                        </el-tooltip>
                                    </div>
                                </div>
                            </vue-seamless-scroll>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 弹窗 start -->
        <div class="maskModel" v-if="maskState">
            <div class="yearMoney">
                <p class="name">服务内容</p>
                <img
                    src="../../../assets/supervise/normalCanle.png"
                    alt=""
                    srcset=""
                    @click="closeInfo"
                    class="maskClose"
                />
            </div>
            <ul class="maskUl">
                <li class="maskLi">
                    <p class="name">工单号：</p>
                    <p class="content">{{ workInfo.orderNum }}</p>
                </li>
                <li class="maskLi">
                    <p class="name">客户姓名：</p>
                    <p class="content">{{ workInfo.customerName }}</p>
                </li>
                <li class="maskLi">
                    <p class="name">客户电话：</p>
                    <p class="content">{{ workInfo.customerphone }}</p>
                </li>
                <li class="maskLi">
                    <p class="name">客户地址：</p>
                    <p class="content">{{ workInfo.address }}</p>
                </li>
                <li class="maskLi">
                    <p class="name">服务类别：</p>
                    <p class="content">{{ workInfo.servetypename }}</p>
                </li>
                <li class="maskLi">
                    <p class="name">开始服务时间：</p>
                    <p class="content">{{ workInfo.timeStart }}</p>
                </li>
                <li class="maskLi">
                    <p class="name">结束服务时间：</p>
                    <p class="content">{{ workInfo.timeEnd }}</p>
                </li>

                <li class="maskLi">
                    <p class="name">服务时长：</p>
                    <p class="content">{{ workInfo.realPeriod }}分</p>
                </li>
            </ul>
        </div>
        <!-- 弹窗 end -->
        <video-see
            v-if="videoState"
            :userId="userId"
            :closeSP="closeSP"
        ></video-see>
    </div>
</template>
<script>
import request from "@/utils/request.js"
import videoSee from "@/components/shipingtonghua.vue"
import exportVue from "@/utils/exportVue"
export default {
    components: {
        videoSee,
    },
    data() {
        return {
            object3Dlayer: {},
            line3D: {},
            trajectoryTime: [],
            dataIds: [],
            userId: "",
            trajectoryState: false,
            videoState: false,
            maskState: false,
            pickTime: "",
            showPerson: false,
            selectName: "在闲",
            selectIndex: 0,
            selectShow: false,
            queryName: "",
            selcetId: "0",
            total: 0,
            onLine: 0,
            normalInfo: {},
            myMap: null,
            isMap: true,
            polygons: [],
            workList: [],
            workInfo: {},
            concatList: [],
            polygon: [],
            marker: null, //地图标记点
            markers: [],
            recMap: null,
            recIsMap: true,
            selectList: [
                { id: 0, name: "在闲" },
                { id: 2, name: "在忙" },
            ],
            govList: [{}],
            tableData: [],
            personList: [],
            markerPerson: [],
            provinceList: [],
            cityList: [],
            areaList: [],
            streetList: [],
            communityList: [],
            personInfo: {},
            timeEnd: "",
            timeStart: "",
            trajectoryId: "",
            feetTime: null,
            getTrajectoryList: [],
        }
    },
    computed: {
        classOption() {
            return {
                step: 0.2, // 数值越大速度滚动越快
                limitMoveNum: 2, // 开始无缝滚动的数据量 this.dataList.length
                hoverStop: true, // 是否开启鼠标悬停stop
                direction: 1, // 0向下 1向上 2向左 3向右
                openWatch: true, // 开启数据实时监控刷新dom
                singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
                singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
                waitTime: 1000, // 单步运动停止的时间(默认值1000ms)
            }
        },
        centerFull() {
            this.$forceUpdate()
            return this.$store.state.centerFull
        },
    },
    created() {
        this.getOrg()
        // 获取异常工单
        this.getAbnormal()
        // 话务列表
        this.getConcat()
        // 工单列表
        this.getWorks()
        exportVue.$on("dataIds", (data) => {
            if (data) {
                this.dataIds = data
            }
        })
    },
    watch: {
        dataIds(val) {
            if (val) {
                this.getWorks(val)
                this.getConcat(val)
                this.getPeron(val)
                this.getAbnormal(val)
            }
        },
    },
    _methods: {
        // 工单系统
        getWorks(dataIds) {
            request({
                url: "/jjyl/servicePgd/info/findServicepgd",
                method: "POST",
                data: {
                    timeEnd: this.timeEnd,
                    timeStart: this.timeStart,
                    pageNo: 1,
                    pageSize: -1,
                    servePersonPhone: this.personInfo.phone,
                    dataIds: dataIds,
                },
            }).then((res) => {
                if (res.code == 200) {
                    if (res.content == null || res.content == "null") {
                        this.workList = []
                        return
                    }
                    this.workList = []
                    this.workList = res.content.list
                }
            })
        },
        // 查询话务
        searchHua() {
            // console.log(this.dataIds,"this.dataIds");
            let dataId = []
            if (this.dataIds.length > 0) {
                dataId = this.dataIds
            } else {
                dataId = null
            }
            request({
                url: "/jjyl/agentState/info/agentViewInfo",
                // url:"/jjyl/agentState/info/agentInfo",
                method: "POST",
                data: {
                    // actionType: this.selcetId,
                    // pageNo: 1,
                    // pageSize: -1,
                    // userName: this.queryName,
                    // ActionType:,
                    agentID: this.queryName,
                    dataIds: dataId,
                },
            }).then((res) => {
                if (res.code == 200) {
                    if (res.content == null || res.content == "null") {
                        this.concatList = []
                        return
                    }
                    this.concatList = []
                    this.concatList = res.content
                    this.concatList.forEach((item) => {
                        if (item.actionType == "-1") {
                            let arr = []
                            arr.push(item)
                            this.onLine = arr.length
                        }
                    })
                    this.total = res.content.length
                    //this.getNums()
                }
            })
        },
        // 话务列表
        getConcat(dataIds) {
            request({
                url: "/jjyl/agentState/info/agentViewInfo",
                // url:"/jjyl/agentState/info/agentInfo",
                method: "POST",
                data: {
                    // actionType: this.selcetId,
                    // pageNo: 1,
                    // pageSize: -1,
                    // userName: this.queryName,
                    // ActionType:,
                    // AgentID:this.queryName,
                    dataIds: dataIds,
                },
            }).then((res) => {
                if (res.code == 200) {
                    if (res.content == null || res.content == "null") {
                        this.concatList = []
                        return
                    }
                    this.concatList = []
                    this.concatList = res.content
                    this.concatList.forEach((item) => {
                        if (item.actionType == "-1") {
                            let arr = []
                            arr.push(item)
                            this.onLine = arr.length
                        }
                    })
                    this.total = res.content.length
                    //this.getNums()
                }
            })
        },
        getNums() {
            request({
                url: "/jjyl/agentState/info/info",
                method: "POST",
                data: {},
            }).then((res) => {
                if (res.code == 200) {
                    if (res.content == null || res.content == "null") {
                        this.total = 0
                        this.onLine = 0
                        return
                    }
                    let conent = res.content.content.countInfo
                    // console.log(conent, "数据室")
                    this.total =
                        Number(conent.count0) +
                        Number(conent.count1) +
                        Number(conent.count2) +
                        Number(conent.count3) +
                        Number(conent.count4) +
                        Number(conent.count5) +
                        Number(conent.count6)
                    this.onLine = Number(conent.count1) + Number(conent.count2)
                }
            })
        },
        // 异常工单打点
        clickAbnormal(e) {
            let index = e.target.id
            let item = JSON.parse(e.target.dataset.obj)
            if (item.startlng) {
                this.myMap.remove(this.markers)
                this.markers = []
                if (
                    Number(item.startlat) == Number(item.endlat) &&
                    Number(item.startlng) == Number(item.endlng)
                ) {
                    item.startlat = Number(item.startlat) + 0.003
                }
                // console.log(
                //     item.longitude,
                //     item.latitude,
                //     item.startlng,
                //     item.startlat,
                //     item.endlng,
                //     item.endlat,
                //     "异常工单打点"
                // )
                let city = [
                    {
                        x: item.longitude,
                        y: item.latitude,
                        name: "位置",
                        icon: require("../../../assets/supervise/adIcon2.png"),
                    },
                    {
                        x: item.startlng,
                        y: item.startlat,
                        name: "开始位置",
                        icon: require("../../../assets/supervise/adIcon4.png"),
                    },
                    {
                        x: item.endlng,
                        y: item.endlat,
                        name: "服务结束位置",
                        icon: require("../../../assets/supervise/adIcon1.png"),
                    },
                ]
                city.forEach((e, i) => {
                    this.markers.push(
                        new AMap.Marker({
                            position: [e.x, e.y],
                            icon: new AMap.Icon({
                                image: e.icon,
                                size: new AMap.Size(52, 52),
                                imageSize: new AMap.Size(26, 26),
                            }),
                            label: {
                                offset: new AMap.Pixel(20, 20),
                                content: e.name,
                            },
                        })
                    )
                })
                this.myMap.add(this.markers)
                self.myMap.add(this.polygons)
                this.myMap.setFitView(this.polygons)
            }
        },
        // 服务人员
        getPeron(dataIds) {
           this.myMap.remove(this.markerPerson)
            this.markerPerson = []
            request({
                url: "/jjyl/admin/serviceStaffCustomerCenter/info/findList",
                method: "POST",
                data: {
                    pageNo: 1,
                    pageSize: 100,
                    dataIds: dataIds,
                },
            }).then((res) => {
                if (res.code == 200) {
                    if (res.content == null || res.content == "null") {
                        this.personList = []
                        return
                    }
                    let personList = []
                    res.content.list.forEach((item) => {
                        if (item.latitude && item.longitude) {
                            personList.push(item)
                        }
                    })
                    this.getPoints(personList)
                    // this.personList =
                }
            })
        },
        // 打点
        getPoints(data) {
            const self = this
            data.forEach((item) => {
                if (item.longitude && item.latitude) {
                    let marker = new AMap.Marker({
                        position: [item.longitude, item.latitude],
                        icon: new AMap.Icon({
                            image: require("../../../assets/supervise/adIcon2.png"),
                            size: new AMap.Size(50, 50),
                            imageSize: new AMap.Size(20, 20),
                        }),
                        extData: {
                            age: item.personAge,
                            phone: item.personPhone,
                            address: item.address,
                            sex: item.personSex,
                            photo: item.personPhoto,
                            name: item.personName,
                            id: item.id,
                        },
                    })
                    self.markerPerson.push(marker)
                    marker.on("click", self.personClick)
                }
            })
            this.myMap.add(self.markerPerson)
        },
        // 点击事件
        personClick(e) {
            // console.log(e.target.w.extData, "信息")
            this.personInfo = Object.assign({}, e.target.w.extData)
            this.showPerson = true
            this.timeStart = ""
            this.timeEnd = ""
            this.getWorks()
        },
        // 获取异常工单
        getAbnormal(dataIds) {
            request({
                url: "/jjyl/servicePgd/info/findServicepgd",
                method: "POST",
                data: {
                    exceptionType: 1,
                    pageNo: 1,
                    pageSize: 100,
                    states: 7,
                    dataIds: dataIds,
                },
            }).then((res) => {
                if (res.code == 200) {
                    if (res.content == null || res.content == "null") {
                        this.tableData = []
                        return
                    }
                    this.tableData = res.content.list
                }
            })
        },

        // 轨迹
        trajectoryTap() {
            if (this.trajectoryId == "") {
                this.$message.warning("请先选择工单")
            } else {
                this.getTrajectory()
            }
            // this.trajectoryState = !this.trajectoryState
        },
        // 获取轨迹信息
        getTrajectory() {
            const self = this
            request({
                url: "/jjyl/personTrajectory/info/findPersonTrajectory",
                method: "POST",
                data: {
                    servicePersonPhone: self.personInfo.phone,
                    servicepgdId: self.trajectoryId,
                },
            }).then((res) => {
                if (res.code === 200) {
                    let getTrajectoryList = []
                    getTrajectoryList = res.content ? res.content : []
                    if (getTrajectoryList.length > 0) {
                        self.getLine(getTrajectoryList)
                    } else {
                        self.$message.warning("暂无足迹")
                    }

                    // setTimeout(() => {
                    //   slef.getTrajectory()
                    // }, 180000)
                    // console.log("工单详情", res.content)
                    // clearTimeout(self.feetTime)
                }
            })
        },
        // 打点
        potintMap(longitude, latitude) {
            const self = this
            try {
                self.myMap.remove(self.marker)
            } catch (err) {
                console.log(err)
            }
            self.marker = new AMap.Marker({
                // icon: "http://webapi.amap.com/theme/v1.3/markers/n/mark_b.png",
                position: [longitude, latitude],
            })
            self.myMap.add(self.marker)
            self.myMap.setFitView()
        },
        // 显示轨迹
        getLine(data) {
            const self = this
            self.potintMap(data[0].longitude, data[0].latitude)
            try {
                self.myMap.remove(self.object3Dlayer)
            } catch (err) {
                console.log(err)
            }

            // self.object3Dlayer.remove(self.line3D)
            self.line3D = {}
            self.object3Dlayer = {}
            self.object3Dlayer = new AMap.Object3DLayer({ zIndex: 10 })

            self.myMap.add(self.object3Dlayer)

            self.line3D = new AMap.Object3D.Line()
            self.line3D.transparent = true

            let geometry = self.line3D.geometry
            for (var i = 0; i < data.length; i++) {
                let origin = self.myMap.lngLatToGeodeticCoord([
                    data[i].longitude,
                    data[i].latitude,
                ])

                geometry.vertices.push(origin.x, origin.y, 0)
                geometry.vertexColors.push(255, 255, 255, 1)
                let lineDe = {}
                if (i == 0) {
                    lineDe = data[0]
                } else {
                    let b = i - 1
                    lineDe = data[b]
                }
                // console.log(lineDe,'我选择的点')
                let des = self.myMap.lngLatToGeodeticCoord([
                    lineDe.longitude,
                    lineDe.latitude,
                ])
                geometry.vertices.push(des.x, des.y, 0)
                geometry.vertexColors.push(0, 0.4, 1, 0.3)
            }

            self.object3Dlayer.add(self.line3D)
        },
        // 显示视频
        closeSP() {
            this.videoState = false
        },
        concatVideo() {
            this.getUserId(this.dataIds)
        },
        // 显示用户信息
        getUserId(dataIds) {
            const that = this
            request({
                url: "/rbac/admin/user/info/list",
                method: "POST",
                data: {
                    mobile: that.personInfo.phone,
                    pageNo: 1,
                    pageSize: 10,
                    dataIds: dataIds,
                },
            }).then((res) => {
                if (res.code === 200) {
                    if (res.content) {
                        if (res.content.list.length == 0) {
                            that.$message.warning("该服务人员暂时不可视频")
                        } else {
                            console.log(res.content.list[0])
                            that.userId = res.content.list[0].mobile
                            that.videoState = true
                            that.maskState = false
                        }
                    }
                }
            })
        },
        // 显示工单
        closePerson() {
            this.showPerson = false
            this.personInfo = {}
            this.getWorks()
            clearTimeout()
            this.trajectoryId = ""
            this.pickTime = ""
            this.timeStart = ""
            this.timeEnd = ""
        },
        // 点击关闭
        closeInfo() {
            this.maskState = false
            this.workInfo = {}
        },
        // 点击事件
        clickProps(e) {
            // console.log(e.target)
            this.trajectoryId = ""
            this.maskState = true
            let index = e.target.id

            let item = JSON.parse(e.target.dataset.obj)
            if (this.showPerson == true) {
                clearTimeout()
                this.trajectoryId = item.id
            }
            this.workInfo = item
        },
        // 日期修改
        changeTap(val) {
            if (val) {
                this.timeStart = val + " 00:00:00"
                this.timeEnd = val + " 23:59:59"
            } else {
                this.timeStart = ""
                this.timeEnd = ""
            }
            this.getWorks()
        },
        // 选中人员
        personTap(index, item) {
            // this.showPerson = true
        },
        // 选中
        showDrop() {
            this.selectShow = !this.selectShow
        },
        tapChoose(index, name, id) {
            this.selectShow = false
            this.selectIndex = index
            this.selcetId = id
            this.selectName = name
            this.getConcat()
        },
        //获取地址
        getDistricts(name = "中国", params = null) {
            let self = this
            return new Promise((resolve, reject) => {
                var opts = {
                    subdistrict: 1,
                    extensions: "all",
                    showbiz: false, //最后一级返回街道信息
                }
                let district = new AMap.DistrictSearch(opts)
                let geocoder = new AMap.Geocoder({
                    city: "",
                    radius: 1000, //范围，默认：500
                })
                try {
                    self.myMap.remove(self.marker)
                } catch (err) {
                    console.log(err)
                }

                self.marker = new AMap.Marker()
                district.search(name, (status, result) => {
                    if (status == "complete") {
                        resolve(result.districtList[0])
                        if (this.isMap) {
                            this.isMap = false
                            return
                        }
                        let bounds = result.districtList[0].boundaries
                        self.polygon = null
                    }
                })
            }).catch((err) => {
                console.log(err)
            })
        },
          //街道地址列表
        getStreetList(val) {
            let self = this
            return new Promise((resolve, reject) => {
                self.$http
                    .request({
                        url: "/ypt/admin/addressYpe/info/findList",
                        method: "POST",
                        data: {
                            parentId: val,
                            pageNo: 1,
                            pageSize: -1,
                        },
                    })
                    .then((res) => {
                        if (res.code == 200) {
                            if (!res.content) {
                                resolve([])
                                return
                            }
                            this.streetList = res.content.list
                            resolve(res.content.list)
                        } else {
                            resolve([])
                        }
                    })
            }).catch((err) => {
                console.log(err)
            })
        },
        // 社区地址列表
        getCommityList(val) {
            let self = this
            return new Promise((resolve, reject) => {
                self.$http
                    .request({
                        url: "/ypt/admin/standardAddress/info/StandardAddressTree",
                        method: "POST",
                        data: {
                            jiedaoId: val,
                        },
                    })
                    .then((res) => {
                        if (res.code == 200) {
                            if (!res.content) {
                                resolve([])
                                return
                            }
                            resolve(res.content)
                        } else {
                            resolve([])
                        }
                    })
            }).catch((err) => {
                console.log(err)
            })
        },
        getOrg() {
            const self = this
            this.$http
                .request({
                    url: "/rbac/admin/org/info/findOrgById",
                    method: "POST",
                    data: { id: this.$store.state.info.orgId },
                })
                .then(async (res) => {
                    if (res.code == 200) {
                        this.normalInfo = res.content

                        if (res.content.latitude && res.content.longitude) {
                            setTimeout(async () => {
                                await self.$nextTick(() => {
                                    self.loadmap(
                                        res.content.longitude,
                                        res.content.latitude
                                    )
                                    self.getPeron()
                                })
                            }, 30)
                        } else {
                            let provinceList = [],
                                cityList = [],
                                areaList = [],
                                streetList = [],
                                communityList = [],
                                longitude = "",
                                latitude = ""
                            let province = await this.getDistricts()
                            provinceList = province.districtList
                            if (this.normalInfo.provinceId) {
                                let city = await this.getDistricts(
                                    this.normalInfo.provinceId
                                )
                                cityList = city.districtList
                            }
                            if (this.normalInfo.cityId) {
                                let area = await this.getDistricts(
                                    this.normalInfo.cityId
                                )
                                areaList = area.districtList
                            }
                            if (this.normalInfo.areaId) {
                                let street = await this.getStreetList(
                                    this.normalInfo.areaId
                                )
                                streetList = street
                            }
                            if (this.normalInfo.streetId) {
                                let community = await this.getCommityList(
                                    Number(this.normalInfo.streetId)
                                )
                                communityList = community
                            }
                            if (
                                this.normalInfo.orgLevel == 1 ||
                                this.normalInfo.orgLevel == 0
                            ) {
                                provinceList.forEach((item) => {
                                    if (
                                        item.adcode ==
                                        this.normalInfo.provinceId
                                    ) {
                                        latitude = item.center.lat
                                        longitude = item.center.lng
                                    }
                                })
                            } else if (this.normalInfo.orgLevel == 2) {
                                cityList.forEach((item) => {
                                    if (item.adcode == this.normalInfo.cityId) {
                                        latitude = item.center.lat
                                        longitude = item.center.lng
                                    }
                                })
                            } else if (this.normalInfo.orgLevel == 3) {
                                areaList.forEach((item) => {
                                    if (item.adcode == this.normalInfo.areaId) {
                                        latitude = item.center.lat
                                        longitude = item.center.lng
                                    }
                                })
                            } else if (
                                this.normalInfo.orgLevel == 4 ||
                                this.normalInfo.orgLevel == 5
                            ) {
                                streetList.forEach((item, index) => {
                                    if (
                                        item.adcode + index ==
                                        this.normalInfo.streetId
                                    ) {
                                        latitude = item.center.lat
                                        longitude = item.center.lng
                                    }
                                })
                            }

                            setTimeout(async () => {
                                await self.$nextTick(() => {
                                    self.loadmap(longitude, latitude)
                                    self.getPeron()
                                })
                            }, 30)
                        }
                        var polygonArr = []
                        if (res.content.pointPosition) {
                            res.content.pointPosition
                                .split(",")
                                .forEach((e) => {
                                    polygonArr.push(e.split(":"))
                                })
                        }
                        var polygon = new AMap.Polygon({
                            map: self.myMap,
                            path: polygonArr,
                            strokeColor: res.content.gridColour
                                ? res.content.gridColour
                                : "",
                            strokeOpacity: 0.2,
                            strokeWeight: 3,
                            fillColor: res.content.gridColour
                                ? res.content.gridColour
                                : "",
                            fillOpacity: 0.35,
                            extData: {
                                name: res.content.gridColour
                                    ? res.content.orgName
                                    : "",
                            },
                        })
                        this.polygon = polygon
                    } else {
                        this.$message.error(res.message)
                    }
                })
        },
        //加载地图
        loadmap(longitude, latitude) {
            let self = this
            return new Promise((resolve, reject) => {
                self.myMap = new AMap.Map("serveMap", {
                    viewMode: "3D",
                    defaultCursor: "pointer",
                    showBuildingBlock: false,
                    expandZoomRange: true,
                    zooms: [3, 20],
                    pitch: 53,
                    resizeEnable: true,
                    zoom: 5,
                    // postion: [longitude, latitude],
                    mapStyle: "amap://styles/blue",
                })
                if (
                    this.$store.state.orgAreaLevel == 1 ||
                    this.$store.state.orgAreaLevel == 2 ||
                    this.$store.state.orgAreaLevel == 3
                ) {
                    let cities = [this.$store.state.orgAreaName]
                    for (let i = 0; i < cities.length; i++) {
                        self.areaBG(self.myMap, cities[i])
                        // self.myMap.setZoom(8)
                        self.myMap.setZoomAndCenter(6, [longitude, latitude])
                    }
                } else if (
                    this.$store.state.orgAreaLevel == 4 ||
                    this.$store.state.orgAreaLevel == 5
                ) {
                    console.log("社区，街道", this.$store.state.orgId)

                    if (this.$store.state.orgId != 0) {
                        this.$http
                            .request({
                                url: "/rbac/admin/org/info/findOrgById",
                                method: "POST",
                                data: {
                                    id: this.$store.state.orgId,
                                },
                            })
                            .then((res) => {
                                var polygonArr = []
                                res.content.pointPosition
                                    .split(",")
                                    .forEach((i) => {
                                        console.log(i)
                                        polygonArr.push(i.split(":"))
                                    })
                                self.polygon = new AMap.Polygon({
                                    map: self.myMap,
                                    strokeWeight: 1,
                                    path: polygonArr,
                                    fillOpacity: 0.3,
                                    fillColor: "#2191E6",
                                    strokeColor: "#007CDB",
                                })
                                let maxlng = polygonArr[0].lng
                                for (
                                    let i = 0;
                                    i < polygonArr.length - 1;
                                    i++
                                ) {
                                    maxlng =
                                        maxlng < polygonArr[i + 1].lng
                                            ? polygonArr[i + 1].lng
                                            : maxlng
                                }
                                let minlng = polygonArr[0].lng
                                for (
                                    let i = 0;
                                    i < polygonArr.length - 1;
                                    i++
                                ) {
                                    minlng =
                                        minlng > polygonArr[i + 1].lng
                                            ? polygonArr[i + 1].lng
                                            : minlng
                                }
                                let lngs =
                                    parseInt(minlng) +
                                    (parseInt(maxlng) - parseInt(minlng)) / 2
                                let maxlat = polygonArr[0].lat
                                for (
                                    let i = 0;
                                    i < polygonArr.length - 1;
                                    i++
                                ) {
                                    maxlat =
                                        maxlat < polygonArr[i + 1].lat
                                            ? polygonArr[i + 1].lat
                                            : maxlat
                                }
                                let minlat = polygonArr[0].lat
                                for (
                                    let i = 0;
                                    i < polygonArr.length - 1;
                                    i++
                                ) {
                                    minlat =
                                        minlat > polygonArr[i + 1].lat
                                            ? polygonArr[i + 1].lat
                                            : minlat
                                }
                                let lats =
                                    parseInt(minlat) +
                                    (parseInt(maxlat) - parseInt(minlat)) / 2
                                self.myMap.setZoomAndCenter(7, [lngs, lats])
                                // self.myMap.setZoomAndCenter(14, [polygonArr[0].lng, polygonArr[0].lat])
                                self.polygon.setMap(self.myMap)
                            })
                    }
                }
                resolve()
            })
        },
        areaBG(map, cityName) {
            console.log(cityName, "cityName")
            AMap.service("AMap.DistrictSearch", function () {
                let opts = {
                    subdistrict: 0,
                    extensions: "all",
                    level: "district", // 查询行政级别为市
                }
                // 实例化DistrictSearch
                let district = new AMap.DistrictSearch(opts)
                district.setLevel("district")
                // 行政区查询
                district.search(`${cityName}`, function (status, result) {
                    // 获取边界信息
                    let bounds = result.districtList[0].boundaries
                    let polygons = []
                    if (bounds) {
                        for (let i = 0, l = bounds.length; i < l; i++) {
                            // 生成行政区划polygon
                            let polygon = new AMap.Polygon({
                                map: map,
                                strokeWeight: 1,
                                path: bounds[i],
                                fillOpacity: 0.3,
                                fillColor: "#2191E6",
                                strokeColor: "#007CDB",
                            })
                            polygons.push(polygon)
                            console.log(polygon)
                        }
                    }
                })
            })
        },
        destroyed() {
            clearTimeout()
        },
    },
    get methods() {
        return this._methods
    },
    set methods(value) {
        this._methods = value
    },
}
</script>
<style lang="less" scoped>
.homeMain {
    position: relative;
    padding: 0px 12px;
    display: flex;
    max-width: 1920px;
    margin: auto;
    .serveTitle {
        color: #fff;
        font-size: 16px;
        font-weight: bold;
        padding-left: 22px;
        padding-top: 20px;
    }
    .companyImg {
        width: 100%;
        height: 100%;
        position: absolute;
        left: 0;
        top: 0;
        z-index: 10;
    }
    .homeLeft {
        flex: 1;
        width: 0;
        .homeVersion {
            position: relative;
            width: 100%;
            height: 29vh;
            margin-top: 12px;
        }
        .homeMap {
            width: 100%;
            position: relative;
            height: 60vh;
            .trangle {
                width: 34px;
                height: 34px;
                z-index: 1111;
                position: absolute;
                &.trangle1 {
                    left: 0px;
                    top: 0px;
                }
                &.trangle2 {
                    right: -4px;
                    bottom: -4px;
                    transform: rotate(180deg);
                }
                &.trangle3 {
                    left: 0px;
                    bottom: -4px;
                    transform: rotate(-90deg);
                }
            }
            .trangleRight {
                width: 217px;
                height: 96px;
                position: absolute;
                right: -4px;
                top: 0px;
                z-index: 12;
            }
            .serveMap {
                border: 2px solid #2785dc;
                width: 100%;
                height: 100%;
            }
        }
        .serveAbnormal {
            padding: 15px 30px;
            .companyHead {
                background: rgba(30, 61, 105, 1);
                margin: 12px 12px 0px;
                display: flex;
                line-height: 40px;
                color: #fff;
                font-size: 15px;
                height: 40px;
                text-align: center;
                .item {
                    flex: 1;
                }
                .item2 {
                    flex: 2;
                }
            }
            .compayDes {
                height: 12vh;
                overflow: hidden;
                padding: 12px;
                margin-top: 12px;
                position: relative;
                z-index: 20;
                .desItem {
                    cursor: pointer;
                    display: flex;
                    text-align: center;
                    align-items: center;
                    font-size: 14px;
                    line-height: 24px;
                    color: #01b1ff;
                    .item {
                        flex: 1;
                    }
                    .item2 {
                        flex: 2;
                    }
                }
            }
        }
    }
    .homeCenter {
        width: 27%;
        margin-left: 12px;
        position: relative;
        height: 90vh;
        overflow: hidden;
        .centerMain {
            position: relative;
            padding: 70px 12px 0;
            z-index: 20;
            .centerHead {
                display: flex;
                position: relative;
                .centerSelcet {
                    flex: 1;
                    background: rgba(110, 188, 255, 0.25);
                    border-radius: 4px;
                    position: relative;
                    margin-right: 10px;
                    height: 30px;
                    .selectName {
                        color: #fff;
                        line-height: 30px;
                        height: 30px;
                        font-size: 13px;
                        position: relative;
                        span {
                            padding: 0 10px;
                        }
                        .cion {
                            position: absolute;
                            right: 10px;
                            top: 8px;
                            font-size: 14px;
                        }
                    }
                    .selectDrop {
                        position: absolute;
                        left: 0;
                        top: 30px;
                        width: 100%;
                        background: #fff;
                        z-index: 300;
                        font-size: 13px;
                        color: rgba(71, 71, 71, 1);
                        line-height: 24px;
                        span {
                            padding: 0 10px;
                        }
                        .selectCur {
                            color: rgba(1, 177, 255, 1);
                        }
                    }
                }
                .centerInput {
                    width: 24%;
                    margin-right: 10px;
                    line-height: 30px;
                    height: 30px;
                    background: rgba(110, 188, 255, 0.25);
                    border-radius: 4px;
                    ::placeholder {
                        color: #fff;
                    }
                    input {
                        padding: 0 10px;
                        background: none;
                        border: none;
                        line-height: 30px;
                        color: #fff;
                        font-size: 13px;
                        outline: none;
                    }
                }
                .centerButton {
                    margin-right: 10px;
                    line-height: 30px;
                    color: #fff;
                    font-size: 13px;
                    border-radius: 4px;
                    padding: 0 10px;
                    cursor: pointer;
                    background: rgba(43, 148, 242, 1);
                }
                .centerTotal,
                .centerLine {
                    margin-right: 10px;
                    line-height: 30px;
                    height: 30px;
                    background: rgba(110, 188, 255, 0.25);
                    border-radius: 4px;
                    padding: 0 10px;
                    color: #fff;
                    font-size: 13px;
                }
                .centerLine {
                    margin-right: 0px;
                }
            }
            .centerContent {
                display: flex;
                justify-content: flex-start;
                flex-wrap: wrap;
                padding: 10px 0px 0 25px;
                overflow-y: scroll;
                overflow-x: hidden;
                max-height: 77vh;
                .centerItem {
                    width: 33.33%;
                    position: relative;
                    margin-top: 12px;
                    .centerInfo {
                        position: relative;
                        cursor: pointer;
                        width: 127px;
                        height: 58px;
                        align-items: center;
                        display: flex;
                        .centerImg {
                            z-index: 20;
                            position: relative;
                            width: 43px;
                            height: 43px;
                            margin-left: 8px;
                            border-radius: 50%;
                        }
                        .centerName {
                            z-index: 20;
                            position: relative;
                            flex: 1;
                            margin-left: 15px;
                            display: flex;
                            .centerTip {
                                width: 78px;
                                line-height: 40px;
                                font-size: 14px;
                                color: #fff;
                                white-space: nowrap;
                                text-overflow: ellipsis;
                                overflow: hidden;
                            }
                        }
                    }
                }
            }
        }
    }
    .homeRight {
        width: 27.5%;
        margin-left: 12px;
        .verserMain {
            position: relative;
            z-index: 1000;
            padding: 20px;
            .rightTop {
                display: flex;
                align-items: center;
                justify-content: center;
                .icon {
                    width: 19px;
                    height: 19px;
                    margin-right: 10px;
                }
                .name {
                    flex: 1;
                    color: #fff;
                    font-weight: bold;
                    font-size: 16px;
                }
                .rightPick {
                    width: 150px;
                    /deep/.el-input__inner {
                        background: rgba(31, 62, 107, 1);
                        color: rgba(203, 203, 203, 1);
                        border: none;
                    }
                }
            }
            .rightTab {
                display: flex;
                margin-top: 12px;
                line-height: 30px;
                background: rgba(14, 63, 184, 1);
                color: #fff;
                font-size: 14px;
                text-align: center;
                .tabItem {
                    flex: 1;
                }
                .tabItem1 {
                    flex: 2;
                }
            }
            .rightDes,
            .rightDes1 {
                margin-top: 12px;
                height: 77vh;
                overflow: hidden;
            }
            .rightDes1 {
                height: 37vh;
            }
            .desItem {
                display: flex;
                text-align: center;
                align-items: center;
                font-size: 14px;
                line-height: 24px;
                color: #fff;

                .item {
                    width: 33.3%;
                    .rightTip {
                        width: 100%;
                        text-align: left;
                        white-space: nowrap;
                        text-overflow: ellipsis;
                        overflow: hidden;
                    }
                }
                .item2 {
                    width: 33.3%;
                }
            }
        }
        .versionOne {
            position: relative;
            height: 90vh;
            overflow: hidden;
        }
        .versionTwo {
            .twoTop {
                position: relative;
                height: 39vh;
                overflow: hidden;
                .personBox {
                    padding: 20px 18px 0;
                    position: relative;
                    z-index: 1000;
                    display: flex;
                    justify-content: center;
                    .icon {
                        width: 19px;
                        height: 19px;
                        margin-right: 10px;
                    }
                    .name {
                        font-size: 16px;
                        font-weight: bold;
                        color: #fff;
                        flex: 1;
                    }
                    .colse {
                        width: 19px;
                        height: 19px;
                        cursor: pointer;
                    }
                }
                .personModel {
                    margin: 15px 18px 0;
                    border-bottom: 1px solid rgba(110, 188, 255, 0.5);
                    padding-bottom: 20px;
                    .personFlex {
                        display: flex;
                        justify-content: center;
                        .img {
                            width: 110px;
                            height: 110px;
                            margin-right: 15px;
                            margin-top: 5px;
                        }
                        .personConent {
                            flex: 1;
                            color: rgba(255, 255, 255, 1);
                            font-size: 14px;
                            line-height: 30px;
                        }
                    }
                    .personAddress {
                        display: flex;
                        line-height: 24px;
                        color: #fff;
                        font-size: 14px;
                        padding-top: 10px;
                        .icon {
                            width: 15px;
                            height: 15px;
                            margin-right: 10px;
                            position: relative;
                            top: 5px;
                        }
                        .name {
                            flex: 1;
                        }
                    }
                }

                .personOperate {
                    padding: 15px 30px;
                    display: flex;
                    justify-content: space-between;
                    position: relative;
                    z-index: 1500;
                    .btn {
                        width: 35%;
                        line-height: 35px;
                        color: #fff;
                        font-size: 14px;
                        text-align: center;
                        cursor: pointer;
                        border-radius: 5px;
                        &.videoBtn {
                            background: rgba(251, 184, 40, 1);
                        }
                        &.feetBtn {
                            background: rgba(44, 209, 192, 1);
                        }
                    }
                }
                .trajectorySearch {
                    padding: 7px 30px;
                    display: flex;
                    justify-content: space-between;
                    position: relative;
                    z-index: 1500;
                    .datae {
                        flex: 1;
                        margin-right: 20px;
                        /deep/.el-input__inner,
                        /deep/.el-range-input {
                            border: none;
                            background: rgba(31, 62, 107, 1);
                            color: #fff;
                        }
                        /deep/.el-range-separator {
                            color: #fff;
                        }
                    }
                    .btn {
                        border-radius: 4px;
                        background: rgba(43, 148, 242, 1);
                        width: 75px;
                        line-height: 35px;
                        height: 35px;
                        color: #fff;
                        font-size: 14px;
                        text-align: center;
                        cursor: pointer;
                    }
                }
            }
            .twoBottom {
                margin-top: 1vh;
                position: relative;
                height: 50vh;
                overflow: hidden;
            }
        }
    }
}
.maskModel {
    width: 390px;
    height: 360px;
    border: 2px solid rgba(110, 188, 255, 1);
    background: rgba(2, 29, 54, 1);
    position: absolute; /*参照物是父容器*/
    left: 50%;
    top: 20%;
    transform: translateX(-50%); /*百分比的参照物是自身*/
    z-index: 2000;
    padding: 20px;
    .yearMoney {
        display: flex;
        justify-content: center;
        .name {
            font-weight: bold;
            color: #fff;
            font-size: 16px;
            flex: 1;
        }
        .maskClose {
            width: 19px;
            height: 19px;
            cursor: pointer;
        }
    }
    .maskUl {
        margin-top: 20px;
        .maskLi {
            line-height: 37px;
            color: rgba(43, 148, 242, 1);
            font-size: 15px;
            display: flex;
            .name {
                width: 120px;
                text-align: right;
                margin-right: 10px;
            }
            .content {
                flex: 1;
                width: 0;
            }
        }
    }
}
</style>